<script setup lang="ts">
import AppRouterView from './components/router/AppRouterView.vue'
import AppDebugMode from './AppDebugMode.vue'
import { useLanguageStore } from './stores/settings/language'

const languageStore = useLanguageStore()
</script>

<template>
  <AppRouterView />
  <AppDebugMode />
</template>
